var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7002)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECF3E8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_7002)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7002",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 36,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.5H2V40.5H38V4.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7999 11.6999V9.8999H27.1999V11.6999H28.9999V13.4999H30.7999V18.8999H32.5999V24.2999H30.7999V27.8999H28.9999V29.6999H27.1999V31.4999H23.5999V33.2999H30.7999V35.0999H32.5999V40.4999H7.3999V35.0999H9.1999V33.2999H16.3999V31.4999H12.7999V29.6999H10.9999V27.8999H9.1999V24.2999H7.3999V18.8999H9.1999V13.4999H10.9999V11.6999H12.7999Z",
    fill: "#8D5524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7999 9.8999V11.6999H10.9999V13.4999H9.1999V18.8999H7.3999V24.2999H9.1999V27.8999H10.9999V29.6999H12.7999V31.4999H27.1999V29.6999H28.9999V27.8999H30.7999V24.2999H32.5999V18.8999H30.7999V13.4999H28.9999V11.6999H27.1999V9.8999H12.7999Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8003 18.8999H14.6003V20.6999H12.8003V18.8999ZM25.4003 18.8999H27.2003V20.6999H25.4003V18.8999Z",
    fill: "#F7FAF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6001 18.8999H16.4001V20.6999H14.6001V18.8999ZM23.6001 18.8999H25.4001V20.6999H23.6001V18.8999Z",
    fill: "#151615"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2002 17.1V15.3H11.0002V13.5H12.8002V15.3H11.0002V17.1H9.2002ZM27.2002 13.5H29.0002V15.3H30.8002V17.1H29.0002V15.3H27.2002V13.5Z",
    fill: "#C24545"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2002 17.1V15.3H11.0002V13.5H12.8002V15.3H11.0002V17.1H9.2002ZM27.2002 13.5H29.0002V15.3H30.8002V17.1H29.0002V15.3H27.2002V13.5Z",
    fill: "#151615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2002 26.1001H21.8002V27.9001H18.2002V26.1001Z",
    fill: "#E35D6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6001 13.4999V15.2999H7.4001V17.0999H11.0001V13.4999H12.8001V9.8999H9.2001V11.6999H7.4001V13.4999H5.6001ZM16.4001 11.6999H20.0001V13.4999H23.6001V11.6999H25.4001V9.8999H16.4001V11.6999ZM27.2001 13.4999H29.0001V17.0999H32.6001V15.2999H34.4001V13.4999H32.6001V11.6999H30.8001V9.8999H27.2001V13.4999Z",
    fill: "#C24545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 40.5V35.1H9.1999V33.3H16.4485L16.3999 31.5H23.5999L23.6197 33.3H30.7999V35.1H32.5999V40.5H7.3999Z",
    fill: "#44C585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 40.4998V35.0998H9.1999V33.2998H30.7999V35.0998H32.5999V40.4998H7.3999Z",
    fill: "#F7FAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 40.5002V38.7002H29.0001V40.5002H23.6001Z",
    fill: "#F7FAF6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7002"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_7002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(2 4.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.dca1f8969ec110d6ce1210dd6de4e190.svg";
export { ForwardRef as ReactComponent };